import type { WsEvent } from '@voice-assistant/shared';

/**
 * Agent Runs — the C→S control wire bridge (SLSWire precedent, sessionLoadStore.ts).
 *
 * Module-level settable emit so components can send WORKFLOW_KILL / WORKFLOW_DISMISS without
 * importing the socket hook (which would be a circular import) and WITHOUT the store touching
 * the wire: `workflowProgressStore` stays wire-free (R-A1/R-A2 — `requestKill`/`dismissRun`
 * remain pure local intent; the component invokes the store action AND this bridge side by
 * side, and the phase still moves only on the server's `run_finished`).
 *
 * The event parameter is typed `WsEvent` so tsc enforces an enum MEMBER, never a bare string —
 * the backend `@SubscribeMessage` decorators match on the enum VALUE (`'workflow_kill'`), and
 * a bare enum-KEY string (`'WORKFLOW_KILL'`) would silently never reach the server (the
 * 2026-06-10 SWITCH_SESSION outage class).
 */
export type WorkflowControlEmit = (event: WsEvent, data: unknown) => void;

let _emit: WorkflowControlEmit | null = null;

/** Bound by useSocket on every render — idempotent (closes over a stable socketRef). */
export function initWorkflowControlWire(emit: WorkflowControlEmit): void {
  _emit = emit;
}

/** No-op until the socket binds: a control click before connect is dropped, never queued. */
export function emitWorkflowControl(event: WsEvent, data: unknown): void {
  _emit?.(event, data);
}
